<template>
    <div>
        <Menus></Menus>
        <Main></Main>
        <Footer></Footer>
    </div>
</template>

<script>
import Main from "./auth/profile";
import Menus from "./menu";
import Footer from "./footer";
export default {
    components: {
        Main,
        Menus,
        Footer,
    },
    props: {
        data: null,
        config: null,
    },
};
</script>
